// extracted by mini-css-extract-plugin
export var banner = "_2u-0";
export var icon = "_2u-1";
export var message = "_2u-2";